// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1ZC6o","label":"CategoryService_label__QUR3J","location":"CategoryService_location__NkH44"};